export const trimUrlForRedirect = (url: string): string => {
    let endpoint = url.split('?')[0];
    if (endpoint.endsWith('/')) endpoint = endpoint.substring(0, endpoint.length - 1);
    return endpoint;
}